module.exports = __webpack_public_path__ + "static/media/left.d9ac2ca5.svg";